import { render, staticRenderFns } from "./LocalizedLink.vue?vue&type=template&id=5a889965&"
import script from "./LocalizedLink.vue?vue&type=script&lang=js&"
export * from "./LocalizedLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports